import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as Actions from "./actions";
import * as Api from "./api";


function* loadProtocolsRequestHandler() {
  try {
    const { response } = yield call(Api.loadProtocols);
    yield put(Actions.loadProtocols.success(response));
  } catch (error) {
    yield put(Actions.loadProtocols.failure(error));
  }
}

function* watchLoadProtocoslRequest() {
  yield takeLatest(Actions.PROTOCOLS.REQUEST, loadProtocolsRequestHandler);
}

function* loadAgreementsRequestHandler() {
  try {
    const { response } = yield call(Api.loadAgreements);
    yield put(Actions.loadAgreements.success(response));
  } catch (error) {
    yield put(Actions.loadAgreements.failure(error));
  }
}

function* watchLoadAgreementsRequest() {
  yield takeLatest(Actions.AGREEMENTS.REQUEST, loadAgreementsRequestHandler);
}

function* loadAgreementFilesRequestHandler(action) {
  try {
    const { response } = yield call(Api.loadAgreementFiles, action.payload.file);
    yield put(Actions.loadAgreementFiles.success(response));
  } catch (error) {
    yield put(Actions.loadAgreementFiles.failure(error));
  }
}

function* watchLoadAgreementFilesRequest() {
  yield takeLatest(Actions.AGREEMENT_FILES.REQUEST,
    loadAgreementFilesRequestHandler);
}

export default function* clinicalContentSagas() {
  yield all([
    fork(watchLoadProtocoslRequest),
    fork(watchLoadAgreementsRequest),
    fork(watchLoadAgreementFilesRequest),
  ]);
}
